import script from "./AppSider.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppSider.vue?vue&type=script&lang=ts&setup=true"

import "./AppSider.vue?vue&type=style&index=0&id=1ec2831c&lang=css"

const __exports__ = script;

export default __exports__